<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <TareaCalendario></TareaCalendario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Tarea',
  components: {
    TareaCalendario: () => import('../components/TareaCalendario')
  },
  data: () => ({
    page: {
      title: 'Calendario Y Comités'
    },
    breadcrumbs: [
      {
        text: 'Calendario Y Comités',
        disabled: true
      },
      {
        text: 'Proyectos',
        disabled: false
      }
    ]
  }),
  methods: {}
};
</script>
